import { injectable } from "inversify";
import databaseInstance from "../../index";
import Axios from "axios";
import appConfig from "appConfig";
import { getStartAndEndTime } from "./domain";

@injectable()
export class PageBuilderService {
  private dbInstance: any = databaseInstance;

  private static instance: PageBuilderService;

  constructor() {
    PageBuilderService.instance = this;
  }

  public static getInstance() {
    if (!PageBuilderService.instance) {
        PageBuilderService.instance = new PageBuilderService();
    }
    return PageBuilderService.instance;
  }

  public getCommunityPages: (
    groupId: number,
    page: number,
    searchString?: string,
  ) => Promise<void> = (groupId, page, searchString) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
      .get(`/groups/${groupId}/pages?page=${page}${searchString ? `&search=${searchString}` : ''}`)
      .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  }

  public getSinglePage: (
    groupId: number,
    pageId: number,
  ) => Promise<void> = (groupId, pageId) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
      .get(`/groups/${groupId}/pages/${pageId}`)
      .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  }

  public createCommunityPage: (
    groupId: number,
    pageDetails: any,
  ) => Promise<void> = (groupId, pageDetails) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
      .post(`/groups/${groupId}/pages`, pageDetails)
      .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  }

  public updateCommunityPage: (
    groupId: number,
    pageId: number,
    pageDetails: any,
  ) => Promise<void> = (groupId, pageId, pageDetails) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
      .put(`/groups/${groupId}/pages/${pageId}`, pageDetails)
      .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  }

  public addBlocksToPage: (
    groupId: number,
    pageId: number,
    blocksData: any,
  ) => Promise<void> = (groupId, pageId, blocksData) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
      .post(`/groups/${groupId}/pages/${pageId}/blocks`, blocksData)
      .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  }

  public uploadBlockImages: (
    groupId: number,
    pageId: number,
    imagesData: any,
  ) => Promise<void> = (groupId, pageId, imagesData) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
      .post(`/groups/${groupId}/pages/${pageId}/block-uploads`, imagesData)
      .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  }

  public previewPage: (
    groupId: number,
    pageId: number,
  ) => Promise<void> = (groupId, pageId) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
      .post(`/groups/${groupId}/pages/${pageId}/preview`)
      .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  }

  public publishPage: (
    groupId: number,
    pageId: number,
  ) => Promise<void> = (groupId, pageId) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
      .post(`/groups/${groupId}/pages/${pageId}/publish`)
      .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  }

  public unpublishPage: (
    groupId: number,
    pageId: number,
  ) => Promise<void> = (groupId, pageId) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
      .delete(`/groups/${groupId}/pages/${pageId}/publish`)
      .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  }

  public getLivePage: (
    groupId: number,
    pageId: number,
  ) => Promise<void> = (groupId, pageId) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
      .get(`/groups/${groupId}/pages/${pageId}/live`)
      .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  }

  public duplicatePage: (
    groupId: number,
    pageId: number,
  ) => Promise<void> = (groupId, pageId) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
      .post(`/groups/${groupId}/pages/${pageId}/duplicate`)
      .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  }

  public deletePage: (
    groupId: number,
    pageId: number,
  ) => Promise<void> = (groupId, pageId) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
      .delete(`/groups/${groupId}/pages/${pageId}`)
      .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  }

  public getGoogleFonts: () => Promise<void> = () => {
    return new Promise<void>((resolve, reject) => {
      Axios.get(`https://www.googleapis.com/webfonts/v1/webfonts?key=${appConfig.google_fonts.api_key}`)
      .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  }

  public addWidgetsToPage: (
    groupId: number,
    pageId: number,
    widgetsData: any,
  ) => Promise<void> = (groupId, pageId, widgetsData) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
      .post(`/groups/${groupId}/pages/${pageId}/widgets`, widgetsData)
      .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  }

  public submitFormLead: (
    groupId: number,
    formType: string,
    formId: number,
    submissionData: any,
  ) => Promise<void> = (groupId, formType, formId, submissionData) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
      .post(`/groups/${groupId}/${formType}/${formId}/lead-submission`, submissionData)
      .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  }

  public getCommunityWidgets: (
    groupId: number,
    query?: string
  ) => Promise<void> = (groupId, query) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
      .get(`/groups/${groupId}/widgets${query ? `?${query}` : ''}`)
      .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  }

  public getCommunityLeads: (
    groupId: number,
    query?: string
  ) => Promise<void> = (groupId, query="") => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
      .get(`/groups/${groupId}/leads${query}`)
      .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  }

  public getCommunityLeadables: (
    groupId: number,
  ) => Promise<void> = (groupId) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
      .get(`/groups/${groupId}/leadables`)
      .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  }

  public exportFormLeads: (
    groupId: number,
    type: string,
    widgetId: number,
  ) => Promise<void> = (groupId, type, widgetId) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
      .post(`/groups/${groupId}/${type}/${widgetId}/leads/export`)
      .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  }

  public getCommunityLandingPages: (
    groupId: number,
    searchString?: string,
  ) => Promise<void> = (groupId, searchString = "") => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .get(`/groups/${groupId}/pages${searchString}`)
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  }

  public getCalendlyEventTypes: (
    groupId: number,
  ) => Promise<void> = (groupId) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
      .post(`/groups/${groupId}/third-party-applications/18/resource-search`, {
        action: 'getEventTypes',
      })
      .then((response: any) => resolve(response))
      .catch((error: any) => reject(error));
    });
  }

  public getCalendlyEventAvailableTimes: (
    groupId: number,
    eventTypeUri: string
  ) => Promise<void> = (
    groupId,
    eventTypeUri,
  ) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
      .post(`/groups/${groupId}/third-party-applications/18/resource-search`, {
        action: 'getEventAvailableTimes',
        event_type_uri: eventTypeUri,
        start_time: 
          getStartAndEndTime().startTime,
        end_time: 
          getStartAndEndTime().endTime,
      })
      .then((response: any) => resolve(response))
      .catch((error: any) => reject(error));
    });
  }

  public getLandingPagesTemplates: () => Promise<void> = () => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .get(`/landing-page-templates`)
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  }

  public loadMoreLandingPagesTemplates: (page: number) => Promise<void> = (page) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .get(`/landing-page-templates?page=${page}`)
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  }

  public getSingleLandingPageTemplate: (pageId: number) => Promise<void> = (pageId) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .get(`/landing-page-templates/${pageId}`)
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  }

  public previewLandingPageTemplate: (pageId: number | string) => Promise<void> = (pageId) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .get(`/landing-page-templates/${pageId}/preview`)
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  }

  public getLeadables: (groupId: number, pageId: number) => Promise<void> = (groupId, pageId) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .get(`/groups/${groupId}/pages/${pageId}/leadables`)
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  }

  public createPageHeader: (groupId: number, headerData: any) => Promise<void> = (groupId, headerData) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .post(`/groups/${groupId}/community-page-headers`, headerData)
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  }

  public createPageFooter: (groupId: number, footerData: any) => Promise<void> = (groupId, footerData) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .post(`/groups/${groupId}/community-page-footers`, footerData)
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  }

  public updatePageHeader: (groupId: number, headerId: number, headerData: any) => Promise<void> = (groupId, headerId, headerData) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .put(`/groups/${groupId}/community-page-headers/${headerId}`, headerData)
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  }

  public updatePageFooter: (groupId: number, footerId: number, footerData: any) => Promise<void> = (groupId, footerId, footerData) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .put(`/groups/${groupId}/community-page-footers/${footerId}`, footerData)
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  }

  public getPageHeaders: (groupId: number, query?: string) => Promise<void> = (groupId, query='') => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .get(`/groups/${groupId}/community-page-headers${query}`)
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  }

  public getPageFooters: (groupId: number, query?: string) => Promise<void> = (groupId, query='') => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .get(`/groups/${groupId}/community-page-footers${query}`)
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  }

  public getPageMenus: (groupId: number, query?: string) => Promise<void> = (groupId, query='') => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .get(`/groups/${groupId}/community-navigation-elements${query}`)
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  }

  public deletePageMenu: (groupId: number, menuId: number) => Promise<void> = (groupId, menuId) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .delete(`/groups/${groupId}/community-navigation-elements/${menuId}`)
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  }

  public duplicatePageMenu: (groupId: number, menuId: number) => Promise<void> = (groupId, menuId) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .post(`/groups/${groupId}/community-navigation-elements/${menuId}/duplicate`)
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  }

  public getUpcomingEventsByDays: (groupId: number, days: number, query?: string) => Promise<void> = (groupId, days, query='') => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .get(`/groups/${groupId}/upcoming-events?days=${days}${query}`)
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  }
}
